import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { randomString } from 'src/app/_core/_function/randomid';
import { DataService } from 'src/app/_services/data.service';
import { Offer } from '../../../_core/_interface/offer';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { map } from 'rxjs/operators';
import {FormControl, FormGroup, MinLengthValidator,  ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-offer',
  templateUrl: './add-offer.component.html',
  styleUrls: ['./add-offer.component.scss']
})
export class AddOfferComponent implements OnInit {
  offer: Offer = {
    flatsArray: [],
    buildingId: '',
    freeText: '',
    id: '',
    projId: '',
    projectId: '',
    secondFreeText: '',
    secondTitle: '',
    shareDynamicGallery: [],
    shareGalleries: '',
    title: '',
    uid: '',
    price: 0,
    user: {
      compId: '',
      email: '',
      displayName: '',
      phone: 0,
      uid: ''
    },
    client: {
      name: '',
      email: '',
      dateCreation: 0,
      phone: 0,
      areaCode: '+972'
    }
  }
  editState: boolean;
  itemToEdit: any;
  projUid: string;
  compId: string;
  offers: any;
  proj:any;
  editState2: boolean;
  itemToEdit2: any;
  building: any;
  currentFlat: any;
  flatId: string;
  flatProperties: any;
  curFloor: string;
  buildingId: any;
  routeNavigate: any;
  user: any;
  areaCode: string = '+972';
  areaCodes: any[] = ['+972', '+7', '+357', '+380', '+1'];
  addOffer = new FormGroup({
    name: new FormControl('', Validators.required),
    phone: new FormControl('', Validators.required),
    areaCode: new FormControl('', Validators.required),
    email: new FormControl(''),
    freetext: new FormControl(''),
    price: new FormControl('')
  })
  // name = new FormControl('', [Validators.required])
  // phone = new FormControl('', [Validators.required])

  constructor(private dataService: DataService, private route: ActivatedRoute, private router: Router, @Inject(MAT_DIALOG_DATA) public data: any) { 

    
  }
  
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      console.log(params);
      // {page: '2' }
      this.buildingId = this.route.snapshot.paramMap.get('buid');
    })
    console.log(this.data)
    this.proj = this.data.proj[0];
    if(!this.data.flat.floorTitle){
      this.data.flat.floorTitle = "";
    }
    this.currentFlat = this.data.flat;
    this.user = this.data.user;
    // this.projUid = this.route.snapshot.paramMap.get('idp');
    // this.compId = this.route.snapshot.paramMap.get('id');
    this.dataService.getSpecProject(this.proj.uid).subscribe(proj => {
      this.proj = proj[0];
      this.dataService.getOffersByProjId(this.proj.id).subscribe(offers => {
        this.offers = offers;
        console.log(this.offers);
        this.ifUserOnline();
      });
    })
    // this.dataService.getSpecBuilding(this.route.snapshot.paramMap.get('buid')).subscribe(building => {
    //   this.building = building[0];
    //   console.log(this.building);

    //   let floors = this.building.floors;
    //   floors.forEach(floor => {
    //     let currentFlats = floor.floor.flats.filter(flat => flat.id === this.flatId);
    //     if (currentFlats.length > 0) {
    //       this.currentFlat = currentFlats[0];
    //       this.curFloor = floor.floor;
    //       console.log('flatT: ', this.currentFlat);
    //     }
    //   });
    //   // if (this.currentFlat) {
    //   //   if (this.currentFlat.faltPrototype !== '' || this.currentFlat.faltPrototype !== undefined) {
    //   //     this.dataService
    //   //       .getSpecFlatPrototypeView(this.currentFlat.faltPrototype)
    //   //       .subscribe(prototype => {
    //   //         this.flatProperties = prototype;
    //   //         if (this.flatProperties.length > 0) {
    //   //           if (this.flatProperties[0].sideNames) {
    //   //             const flatViewName = this.flatProperties[0].sideNames[0];
    //   //             if (this.curFloor[flatViewName]) {
    //   //               this.items[0].curFloorPanorama = this.curFloor[flatViewName];
    //   //             }
    //   //           }
    //   //         }
    //   //       });
    //   //   }
    //   // }
    // })

    // switch (window.location.host) {
    //   case 'getkey1.online':
    //     this.routeNavigate = 'https://getkey1.online';
    //     break;
    //   case 's-katorza.com':
    //     this.routeNavigate = 'https://s-katorza.com';
    //     break;
    //   case 'spirical.net':
    //     this.routeNavigate = 'https://spirical.net';
    //     break;
    //     case 'localhost:4200':
    //       this.routeNavigate = 'http://localhost:4200';
    //       break;
    //   default:
    //     this.routeNavigate = 'https://spirical.net'
    // }

    this.routeNavigate = this.dataService.hoisUrl();
  }
  onChangeAreaCode(code) {
    this.areaCode = code
  }
  getErrorMessage() {
    // if (this.addOffer.value.name.hasError('required')) {
    //   return 'עליך להזין שם';
    // } 
    // if (this.addOffer.value.phone.hasError('required')) {
    //   return 'עליך להזין טלפון';
    // }

    // return this.name.hasError('email') ? 'Not a valid email' : '';
  }

  goToOffer(offer) {
    // this.router.navigate(['company/' + this.proj.parrentId + '/' + this.proj.uid + '/offers/' + offer.uid]);
    const link = 'company/u/' + this.proj.parrentId + '/' + this.proj.uid + '/offers/' + offer.uid + '?m=all';
    window.open(link, '_blank')
  }
  

  onSubmit() {
    if (this.offer.flatsArray && this.offer.flatsArray.length > 0) {
      const array = this.offer.flatsArray;
      let ifInclude = true;
      let rs = randomString(15);
      // this.offer.id = rs;
      this.offer.uid = rs;
      this.offer.projId = this.proj.id;

      this.offer.flatsArray.forEach((flat, index)=> {
        if(flat.id === this.currentFlat.id){
          ifInclude = false;
          return ifInclude;
        }
      });
      if(ifInclude){
        this.offer.flatsArray.push(this.currentFlat);
      }
    } else {
      this.offer.flatsArray = [];
      this.offer.flatsArray.push(this.currentFlat);
      let rs = randomString(15);
      // this.offer.id = rs;
      this.offer.uid = rs;
      this.offer.projId = this.proj.id;
    }
    if(this.user){
      this.offer.user.compId = this.user.compId;
      this.offer.user.email = this.user.email
      this.offer.user.displayName = this.user.displayName
      if(this.user.phone){
        this.offer.user.phone = this.user.phone;
      }
      this.offer.user.uid = this.user.uid;
      this.dataService.addItem(this.offer, 'offers/');
    }

    // this.addFlatToOffer(this.currentFlat);
    this.clearState();
  }
  ifUserOnline(){
    // this.offers.forEach(offer => {
    //   if (offer.connect) {
    //     if( offer.connect.now ){
    //       if (offer.connect.date + 8000 < Date.now()) {
    //         offer.connect.now = false;
    //         this.dataService.updateItem(offer, 'offers/');
    //       }
    //     }
    //   }
    // })
  }
  editItem(event, item) {
    this.editState = !this.editState;
    this.itemToEdit = item;
  }

  closeEdit(){
    this.editState = false;
  }

  clearState() {
    this.editState = false;
    this.itemToEdit = null;
  }
  deleteItem(event, item) {
    if (confirm('אתה רוצה להסיר הצעה?')) {
      this.clearState();
      this.dataService.deleteItem(item, 'offers/');
    }
  }
  editItem2(event, item) {
    this.editState2 = true;
    this.itemToEdit2 = item;
  }
  onSubmit3(offer){
    if(!offer.client){
      offer.client = {};
    } 
      offer.client.dateCreation = Date.now();
      this.editState2 = false; 
      this.dataService.updateItem(offer, 'offers/');
      this.clearState();
  }
  addFlatToOffer(item) {
    const array = []
    if (this.offer.flatsArray && this.offer.flatsArray.length > 0) {
      const array = this.offer.flatsArray;
      let ifInclude = true;
      this.offer.flatsArray.forEach((flat, index)=> {
        if(flat.item.id === item.id){
          ifInclude = false;
          return ifInclude;
        }
      });
      if(ifInclude){
        this.offer.flatsArray.push({item});
      }
    } else {
      this.offer.flatsArray = [];
      this.offer.flatsArray.push({item});
    }
    console.log(this.offer.flatsArray);
    this.dataService.updateItem(this.offer, 'offers/')
  }
}
